const firestoreModule = {
  firestorePath: "users/{userId}",
  // The path to a "collection" or single "document" in firestore.
  // You can use `{userId}` which will be replaced with the user Id.
  firestoreRefType: "doc",
  // `'collection'` or `'doc'`. Depending on your `firestorePath`.
  moduleName: "userStore",
  // The module name. eg. `'userItems'`
  // Can also be a nested module, eg. `'user/items'`
  statePropName: "data",
  // The name of the property where the docs or doc will be synced to.
  // always best to set to `'data'` imo!
  // If left blank it will be synced on the state of the module.

  namespaced: true,
  // this is automatically added! See more info at: https://vuex.vuejs.org/guide/modules.html#namespacing

  // EVERYTHING BELOW IS OPTIONAL (only include what you use)
  // Related to the 2-way sync:
  sync: {
    where: [],
    orderBy: [],
    fillables: [],
    guard: [],
    defaultValues: {},
    debounceTimerMs: 1000,
    // HOOKS for local changes:
  },

  // When docs on the server side are changed:
  serverChange: {
    convertTimestamps: {},
    // HOOKS for changes on SERVER:
  },

  // When docs are fetched through `dispatch('module/fetch', {clauses})`.
  fetch: {
    // The max amount of documents to be fetched. Defaults to 50.
    docLimit: 1,
  },

  // You can also add custom state/getters/mutations/actions. These will be added to your module.
  state: {},
  getters: {
    user(state) {
      return state.data;
    },
    uid(state) {
      return state.data.id;
    },
  },
  mutations: {},
  actions: {},
};

export default firestoreModule;
